import { Prop } from '@Ravnur-Inc/decorators';
import { Vue, Options } from 'vue-class-component';

import { array2map } from '../../transformers/array-to-map';
import { $Types } from '../../typings/tsx';

import './checkbox-group.scss';

type Props<E extends Entity = Entity> = {
  entities: E[];
  value?: string[];
  disabled?: boolean;
  prop?: Nullable<keyof SubType<E, string>> | string;
};

type Emits = {
  onInput: (value: string[]) => void;
};

const CN = 'checkbox-group';

@Options({
  name: 'checkbox-group',
  emits: ['input', 'update:value'],
})
export default class CheckboxGroup<E extends Entity> extends Vue {
  declare $props: $Types<Props<E>, Emits, 'value'>;

  @Prop({}) entities!: E[];
  @Prop({ default: [] }) value: string[];
  @Prop({ default: false }) disabled: boolean;
  @Prop({ default: null }) prop: Nullable<keyof E>;

  get selected() {
    return array2map(this.value);
  }

  render() {
    return <ul class={`${CN}`}>{this.entities.map(this.renderItem)}</ul>;
  }

  private renderItem(entity: E) {
    const { selected } = this;
    const { id } = entity;
    const label: string = this.prop ? (entity[this.prop] as any) : '';
    const checked = selected[id] || false;
    return (
      <li key={id} class={`${CN}__item`}>
        <checkbox
          class={`${CN}__checkbox`}
          disabled={this.disabled}
          label={label}
          value={checked}
          onInput={() => this.toggle(id)}
        >
          {this.$slots.item?.({ entity, checked })}
        </checkbox>
      </li>
    );
  }

  private toggle(entityId: string) {
    const value = this.selected[entityId]
      ? this.value.filter((id) => id !== entityId)
      : [...this.value, entityId];
    this.$emit('input', value);
    this.$emit('update:value', value);
  }
}
